<template>
    <div class="grid--con">
        <div v-if="ntcDetailAt == 'N'" class="mgr10 mgl10">
            <div class="board-number-cases">전체 <span>{{paginginfo.totCnt}}</span>건</div>
            <div class="board-list mgt10" >
                <ul>
                    <li v-for="ntcInfo in imprtnNtcList"
                        :key="'imprtntNtc' + ntcInfo.sn"
                        @click="searchNtcDetailInfo(ntcInfo.sn)">
                        <a href="javascript:;">
                            <div class="board-tit-con">
                                <div class="entry-tag" v-if="ntcInfo.clCd=='999'">
                                    <span class="tag02">중요</span>
                                </div>
                                <div class="entry-title">{{ntcInfo.sj}}</div>
                                <div class="entry-date">{{ntcInfo.creatDt.substr(0,10)}}</div>
                            </div>
                        </a>
                    </li>
                    <li v-for="ntcInfo in ntcList"
                        :key="'ntc' + ntcInfo.sn"
                        @click="searchNtcDetailInfo(ntcInfo.sn)">
                        <a href="javascript:;">
                            <div class="board-tit-con">
                                <div class="entry-tag" v-if="ntcInfo.CHK_NEW_NTC=='NEW'">
                                    <span class="tag01">신규</span>
                                </div>
                                <div class="entry-title">{{ntcInfo.sj}}</div>
                                <div class="entry-date">{{ntcInfo.creatDt.substr(0,10)}}</div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
            <pagenavi :paginginfo="paginginfo" class="mgb20" v-if="paginginfo.totCnt > paginginfo.pageListCnt"></pagenavi>
        </div>

        <div v-if="ntcDetailAt == 'Y'" class="mgr10 mgl10">
            <div class="board-view box-type01 mgt20">
                <div class="section-title">
                    <div class="board-tit-con">
                        <div class="entry-tag" v-if="ntcDetailInfo.clCd=='999'">
                            <span class="tag02">중요</span>
                        </div>
                        <div class="entry-title">{{ntcDetailInfo.sj}}</div>
                        <div class="entry-date">{{ntcDetailInfo.creatDt.substr(0, 10)}}</div>
                    </div>
                </div>
                <div class="board-view-con" v-html="ntcDetailInfo.cn"></div>
                <div class="board-view-bt-box">
                    <div class="board-view-bt">
                        <div class="entry-title"><div class="img-com __icon03"><span>첨부파일 아이콘</span></div>첨부파일</div>
                        <div class="entry-con">
                            <div class="file-att-list">
                                <ul>
                                    <li v-for="(ntcFileInfo,index) in ntcFileList"
                                        :key="'ntcFile' + index"
                                        @click="downloadFile(ntcFileInfo)">
                                        <a href="javascript:;">{{ntcFileInfo.orginlNm}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-wrap __right mgt30 mgb20">
                <button class="middle _bt-ypurple" @click="searchNtcList();"><span>목록으로</span></button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "notice_popup",
        props:['params'],
        data: function(){
            return {
                paginginfo: {
                    totCnt: 0, /* 총게시물 수*/
                    pageListCnt: 5, /* 페이지당 게시물수 */
                    pageCnt: 10, /* 페이지당 게시물수 */
                    curPageNum: 1,/* 현재페이지 */
                    callBackFunc:null
                },
                url : '',
                ntcDetailAt : '',
                imprtnNtcList : new Array(),
                ntcList : new Array(),
                ntcDetailInfo : new Array(),
                ntcFileList : new Array()
            }
        },
        methods: {
            searchNtcList : function(){
                const _this = this;

                this.axios.post(this.url + '/cs/notice/searchNoticeList.act',{
                    pagingInfo : {
                        curPageNum : this.paginginfo.curPageNum,
                        startCnt : ((this.paginginfo.curPageNum-1) * this.paginginfo.pageListCnt)+1,
                        endCnt : this.paginginfo.curPageNum * this.paginginfo.pageListCnt
                    }
                }).then(function(response) {
                    this.ntcDetailAt = 'N';
                    this.imprtnNtcList = response.data.ntcInfo.imprtnNtcList;
                    this.ntcList = response.data.ntcInfo.ntcList;
                    this.paginginfo.totCnt = response.data.ntcInfo.pagingInfo.totCnt;
                    this.paginginfo.curPageNum = response.data.ntcInfo.pagingInfo.curPageNum;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            searchNtcDetailInfo : function(sn){
                const _this = this;

                this.axios.post(this.url +'/cs/notice/searchNoticeDetailInfo.act',{
                    sn : sn
                }).then(function(response) {
                    this.ntcDetailAt = 'Y';

                    this.ntcDetailInfo = response.data.ntcInfo.ntcDetailInfo;
                    this.ntcFileList = response.data.ntcInfo.ntcFileList;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            downloadFile : function(ntcFileInfo){
                const url = this.url +'/cs/notice/ntcFileDownLoad.act';
                const params = 'sn='+this.ntcDetailInfo.sn+'&fgrpCd='+ntcFileInfo.fgrpCd+'&fileCd='+ntcFileInfo.fileCd;
                this.$store.getters.getComponents.app.setFileDownLoadUrl(url,params);
            },
            closePopup: function(){
                this.$store.getters.getComponents.popup.close('noticePopup');
            }
        },
        mounted:function(){
            this.paginginfo.callBackFunc = this.searchNtcList;
            
            const url = document.location.href;

            if(url.indexOf('/works') > -1){
                this.url = '/works';
            }else{
                this.url = '/cloud';
            }

            let ntcSe = 'list';

            if(this.params != null&&typeof this.params != 'undefined'){
                ntcSe = this.params.ntcSe;
            }

            if(ntcSe == 'dtl'){
                const sn = this.params.sn;
                this.searchNtcDetailInfo(sn);
            }else{
                this.searchNtcList();
            }
        }
    }
</script>

<style scoped>

</style>